import React from "react";
import { FormattedMessage } from "react-intl";

export const DeviceTypeHeader = () => {
  return (
    <span className="sr-only">
      <FormattedMessage id="device_type" />
    </span>
  );
};
